import Content from './TooltipContent';
import Target from './TooltipTarget';
import Tooltip from './Tooltip';
export default Object.assign(Tooltip, {
    Target,
    Content,
});
